import { render, staticRenderFns } from "./chatSearch.vue?vue&type=template&id=4d9ee82c&"
import script from "./chatSearch.vue?vue&type=script&lang=js&"
export * from "./chatSearch.vue?vue&type=script&lang=js&"
import style0 from "./chatSearch.vue?vue&type=style&index=0&id=4d9ee82c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9ee82c')) {
      api.createRecord('4d9ee82c', component.options)
    } else {
      api.reload('4d9ee82c', component.options)
    }
    module.hot.accept("./chatSearch.vue?vue&type=template&id=4d9ee82c&", function () {
      api.rerender('4d9ee82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/chatSearch.vue"
export default component.exports